import { render, staticRenderFns } from "./DetailsTable.vue?vue&type=template&id=2a1c162b&scoped=true"
import script from "./DetailsTable.vue?vue&type=script&lang=js"
export * from "./DetailsTable.vue?vue&type=script&lang=js"
import style0 from "./DetailsTable.vue?vue&type=style&index=0&id=2a1c162b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1c162b",
  null
  
)

export default component.exports